// Wortlaute der Erklärung „Pakete“. Regeln für jeden Text: siehe ../help.js.
// Die Namen der Felder und Schaltflächen stehen so, wie die Paketseiten sie zeigen (../packet.js).
export default {
  title: "Pakete",
  // Kurznamen der Seiten, für die Kopfzeile, die Zeitleiste und "Weiter zu …".
  section: {
    PacketDetail: "Paket",
    MaterialOverview: "Materialkatalog",
    ProjectDetail: "Projekt",
    CustomerDetail: "Kunde",
  },
  // Die Seiten außerhalb der Paketverwaltung, in denen ein Paket steht oder etwas bewirkt. In der Zeitleiste
  // abgesetzt und mit diesem Namen davor.
  related: "Zusammenhänge",
  step: {
    "detail-head": {
      text: "Der Kopf nennt das Paket. Das Symbol links sagt, aus welchem Katalog es bündelt.",
    },
    "detail-name": {
      text: "Der Name ist alles, was das Paket selbst beschreibt. Unter ihm finden Sie es im Projekt und beim Kunden wieder.",
    },
    "detail-items": {
      text: "Darunter steht, was das Paket enthält. Über „Material hinzufügen“ nehmen Sie ein weiteres aus dem Katalog dazu; es erscheint gleich als neue Zeile in der Tabelle.",
    },
    "detail-row": {
      text: "Jede Zeile ist eine Position des Pakets. Ein Klick auf die Zeile öffnet den Eintrag im Katalog, der Papierkorb rechts nimmt ihn wieder heraus. Daneben stehen Abrechnungseinheit und Einkaufspreis, unter dem Namen die Notiz des Eintrags.",
    },
    "detail-save": {
      text: "Speichern schreibt Name und Positionen. Projekte, die das Paket schon übernommen haben, bleiben unverändert.",
    },
    again: {
      text: "Diese Schaltfläche steht auf jeder Seite mit Erklärung. Ein Klick startet sie erneut.",
    },
    // Wo Pakete wirken: der Katalog, der sie auflistet, der Reiter, den ein Paket füllt, und das Fenster,
    // das eines anbietet.
    row: {
      text: "Pakete stehen in der Tabelle ihres Katalogs, über den Materialien. Die Zeile nennt das Paket und die Zahl seiner Positionen.",
    },
    filter: {
      text: "Der Filter über der Tabelle zeigt nur die Pakete, nur die Materialien oder beides.",
    },
    create: {
      text: "Dieselbe Schaltfläche legt auch Pakete an: Neues Paket erstellen macht hier ein Materialpaket. Diese Art lässt sich später nicht mehr ändern.",
    },
    catalogue: {
      text: "Die Materialien selbst stehen daneben, mit Einheit und Einkaufspreis. Ein Paket merkt sich nur, welche dazugehören.",
    },
    "project-register": {
      text: "Im Projekt steht jedes Material einzeln in diesem Reiter. Hinzufügen bringt ein ganzes Paket auf einmal hinein.",
    },
    "project-packet": {
      text: "Die Suche findet Pakete vor den einzelnen Materialien. Ein Klick auf das Paket übernimmt alle Materialien, die dem Projekt noch fehlen.",
    },
    "customer-assign": {
      text: "Auch beim Kunden stehen die Pakete über dem Katalog. Ein Paket legt für jede seiner Positionen eine Preiszeile an.",
    },
  },
}
